import React, { FunctionComponent, Fragment } from 'react';
import { Box } from '@rebass/emotion';
import {
  SeamlessElement1Col,
  SeamlessElement2Col,
  SeamlessElement2ColGrid,
} from '../SeamlessElement';
import { SeamlessSectionProps } from './index';
import ProductPlaceholders from '../ProductPlaceholders';

const SEAMLESS_LAYOUT_1COL = '1col';
const SEAMLESS_LAYOUT_2COL = '2col';
const SEAMLESS_LAYOUT_2COLGRID = '2col-grid';

const SeamlessSection: FunctionComponent<SeamlessSectionProps> = ({
  elements = [],
  loading,
}) => {
  const getLayout = ({ layout, props }): JSX.Element | null => {
    return (
      {
        [SEAMLESS_LAYOUT_1COL]: <SeamlessElement1Col {...props} />,
        [SEAMLESS_LAYOUT_2COL]: <SeamlessElement2Col {...props} />,
        [SEAMLESS_LAYOUT_2COLGRID]: <SeamlessElement2ColGrid {...props} />,
      }[layout] || null
    );
  };

  if (loading) {
    return <ProductPlaceholders count={4} />;
  }

  if (!elements?.length) {
    return null;
  }

  return (
    <Fragment>
      {elements.map(({ layout, ...props }, index) => (
        <Box key={index}>{getLayout({ layout, props })}</Box>
      ))}
    </Fragment>
  );
};

export default SeamlessSection;
